import React, { Component } from 'react'
import { Card, CardBody, Row, Col, Input, Button } from "reactstrap";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { dataCoberturas } from 'redux/selectors/sPymes'
import ValoresCobertura from './ValoresCobertura'
import { data } from '../../../../redux/actions/aMenus';
import NumberFormat from 'react-number-format';


class CompletarCoberturas extends Component {
    constructor(props) {
        super(props)
        const ubSelec = 0
        const generales = {

        }
        this.state = { ubSelec, arrayData: [[]], nota: [], guardar: false, cobGenerales: [], generales, estadoGenerales: false, estadoActualizar: false, hasSiguienteUbicacion: true, cambiaData: 'btn btn-primary' }
        console.log('CONSTRUCTOR')
        // binding es necesario, para cuando se haga la llamada callback desde el componente hijo
        this.setEstadoActualizar = this.setEstadoActualizar.bind(this);
    }
    handleClick = async (datos, i, coberturaEspecial = true) => {
        // props
        const { idCobertura } = this.props
        // visualizar variables de estado del componente
        const { ubSelec, arrayData, nota, guardar, generales, estadoGenerales, estadoActualizar, hasSiguienteUbicacion } = this.state
        // copias de las variables de estado, para no editar el estado directamente
        let stateArrayData
        let stateGuardar
        let stateNota
        let stateGenerales
        let stateEstGenerales
        let stateEstActualizar
        let stateUbSelec
        let stateHasSiguienteUbicacion

        // variables internas                
        let ubicaciones = []
        // Si va a actualizar los valores del tab el usuario
        if (estadoActualizar || !coberturaEspecial) {
            stateUbSelec = ubSelec
            stateHasSiguienteUbicacion = hasSiguienteUbicacion
            // deep copy y agregar el dato correspondiente al tab            
            stateArrayData = [...arrayData]
            if (Array.isArray(datos) && datos.length !== 0) {
                let tabToModify = [...stateArrayData[i]]
                tabToModify = datos
                stateArrayData[i] = tabToModify
            }

            // Llamar al servicio para guardar los datos llenados en el tab
            let res
            res = await this.props.guardarCobertura({ arrayData: stateArrayData, idCobertura, generales })
            // Manejar la respuesta del servicio
            if (res && res.transaccion) {
                stateNota = res.nota ? res.nota : []
                ubicaciones = res.ubicaciones
                stateEstGenerales = res.estadoGenerales
                stateGenerales = res.generales
                let stateArrayData2 = []
                stateArrayData.forEach((item, i) => {
                    let valorItem = []
                    item.forEach((elem, j) => {
                        const val = { ...elem, value: (ubicaciones[i])[elem.codigo] }
                        valorItem.push(val)
                    })
                    stateArrayData2.push(valorItem)
                })
                if (stateArrayData2) {
                    stateArrayData = stateArrayData2
                }
                stateGuardar = true
                stateEstActualizar = false
                // Manejo de botón exterior de actualizar, para cuando se llama en coberturas generales
                if (!coberturaEspecial) {
                    this.setState({ cambiaData: 'btn btn-primary' })
                }
            } else {
                stateUbSelec = ubSelec
                stateGuardar = guardar
            }
            // update state
            this.setState({
                ubSelec: stateUbSelec !== undefined ? stateUbSelec : ubSelec,
                arrayData: stateArrayData !== undefined ? stateArrayData : arrayData,
                nota: stateNota !== undefined ? stateNota : nota,
                guardar: stateGuardar !== undefined ? stateGuardar : guardar,
                generales: stateGenerales !== undefined ? stateGenerales : generales,
                estadoGenerales: stateEstGenerales !== undefined ? stateEstGenerales : estadoGenerales,
                estadoActualizar: stateEstActualizar !== undefined ? stateEstActualizar : estadoActualizar
            })

            if (!guardar) window.scroll(0, 0)
            else window.scroll(0, 400)
        }
        else {
            // condiciones para ir a la siguiente ubicación de la cobertura actual
            if (guardar && !estadoActualizar && ubSelec < arrayData.length - 1) {
                stateUbSelec = ubSelec + 1
                stateHasSiguienteUbicacion = true
                // this.setState({hasSiguienteUbicacion:true})
                console.log('reachable')
                // detectar cuando ya se recorrieron todas las ubicaciones para una cobertura
                if (stateUbSelec === arrayData.length - 1) {
                    stateHasSiguienteUbicacion = false
                    // this.setState({hasSiguienteUbicacion:false})
                    console.log('unreachable')
                }
            }

            // update state
            this.setState({
                ubSelec: stateUbSelec !== undefined ? stateUbSelec : ubSelec,
                hasSiguienteUbicacion: stateHasSiguienteUbicacion !== undefined ? stateHasSiguienteUbicacion : hasSiguienteUbicacion
            })
        }



        // const { arrayUbicaciones, idCobertura } = this.props
        // let { ubSelec, arrayData, nota, guardar, generales, estadoGenerales } = this.state
        // console.log(datos)
        // arrayData[i] = datos

        // const res = await this.props.guardarCobertura({ arrayData, idCobertura, generales })
        // console.log('AAAA1', res, arrayData, ubicaciones)
        // console.log('review_rc', guardar, !this.state.estadoActualizar, ubSelec, arrayData.length - 1)

        // let ubicaciones = []

        // // condiciones para ir a la siguiente ubicación de la cobertura actual
        // if (guardar && !this.state.estadoActualizar && ubSelec < arrayData.length - 1) {
        //     ubSelec = ubSelec + 1
        //     this.setState({hasSiguienteUbicacion:true})
        //     console.log('reachable')
        //     // detectar cuando ya se recorrieron todas las ubicaciones para una cobertura
        //     if (ubSelec === arrayData.length - 1){
        //         this.setState({hasSiguienteUbicacion:false})
        //         console.log('unreachable')
        //     }
        // }

        // if (res.transaccion) {
        //     ubicaciones = res.ubicaciones
        //     estadoGenerales = res.estadoGenerales
        //     console.log('AAAA', res, arrayData, ubicaciones)

        //     let arrayData2 = []
        //     arrayData.forEach((item, i) => {
        //         let valorItem = []

        //         item.forEach((elem, j) => {
        //             const val = { ...elem, value: (ubicaciones[i])[elem.codigo] }
        //             valorItem.push(val)
        //         })
        //         arrayData2.push(valorItem)
        //     })
        //     arrayData = arrayData2
        //     console.log('AAAAres', arrayData)
        //     guardar = true
        //     this.setEstadoActualizar(false)
        // } else {
        //     ubSelec = this.state.ubSelec
        //     guardar = this.state.guardar
        // }
        // if (res.generales)
        //     generales = res.generales

        // this.setState({ arrayData, nota, ubSelec, guardar, estadoGenerales, cambiaData: 'btn btn-primary', generales })

        // if (!guardar) window.scroll(0, 0)
        // ///else window.scroll(0, 400)
    }

    componentDidMount() {
        console.log('PYMES4CDMOUNT')
        this.generarArrayData()
        this.setState({ estadoActualizar: true })
    }

    handleBack = () => {
        this.setState({ hasSiguienteUbicacion: true })
        let { ubSelec } = this.state
        if (ubSelec === 0)
            this.props.handleAtras()
        else {
            ubSelec--
            this.setState({ ubSelec })
        }
    }

    generarArrayData = () => {
        const { arrayUbicaciones, data } = this.props

        let arrayData = []
        arrayUbicaciones.forEach(({ respCivil }) => {

            let data2 = []
            data.forEach(item => { console.log('PYMES4DAta111', Array.isArray(item.valor)); data2.push({ ...item, value: Array.isArray(item.valor) ? "0" : 0 }) })
            if (respCivil) {
                let data3 = []
                data2.forEach(item => {
                    let value = respCivil[item.codigo]
                    data3.push({ ...item, value })
                })
                data2 = data3;
            }
            arrayData.push(data2)
        })
        console.log('PYMES4DAta111222', arrayData)

        const { cobGenerales, generalesValues } = this.props
        let generales = cobGenerales.reduce((i, { codigo }) => ({ ...i, [codigo]: 0 }), {})

        if (generalesValues && generalesValues.generalesRC) {

            for (const key in generalesValues.generalesRC) {
                generales[key] = generalesValues.generalesRC[key]
            }

        }
        this.setState({ arrayData, cobGenerales, generales })
    }

    handleGenerales = (valor, codigo, maximo) => {
        valor = parseFloat(valor)
        if (isNaN(valor)) valor = 0

        if (valor >= 0) {
            maximo = parseFloat(maximo)
            if (valor <= maximo) {
                let { generales } = this.state
                console.log('handleGenerales', valor, codigo, maximo)

                generales = { ...generales, [codigo]: valor }
                this.setState({ generales, cambiaData: 'btn btn-purple fe-pulse', estadoActualizar: true })
            }
        }
    }
    componentDidUpdate(prevProps, prevState) {
        const { cobGenerales } = this.props
        if (cobGenerales !== prevProps.cobGenerales) {
            let generales = cobGenerales.reduce((i, { codigo }) => ({ ...i, [codigo]: 0 }), {})
            this.setState({ cobGenerales, generales: { ...generales, ...this.state.generales } })
        }

    }

    // set para el estado actualizar, que se activa cuando el usuario edita los valores
    setEstadoActualizar = (value) => {
        this.setState({ estadoActualizar: value })
        console.log('clickActualizar', this.state.estadoActualizar, value)
    }

    render() {

        const { ubSelec, arrayData, nota = [], guardar, generales, estadoGenerales, cambiaData } = this.state
        const { arrayUbicaciones, titulo, nombreGiro, idCobertura, cliCodigoCore, cobGenerales, data: maximos } = this.props
        console.log("==================", this.state)

        return (
            <Col md={8}>
                <div className='row' style={{ background: '#e8eaed', margin: 'auto', padding: 10, marginBottom: 10, }}>
                    <Col sm={6}> <h3 style={{ fontWeight: 700, color: '#b6207f', }}>{titulo}</h3> <div style={{}}> Por favor ingrese los valores que desea asegurar </div> </Col>
                    <Col sm={6} style={{ borderLeft: '2px solid #b3b4b6', }} > <h3 style={{ fontWeight: 700, }}> <center> Giro del negocio: </center> </h3> <div style={{ fontSize: '1.3rem', }}> <center> {nombreGiro} </center> </div>  </Col>
                </div>
                <div className='row'>
                    {console.log('review_rc_2', maximos, maximos.length, arrayData, maximos && maximos.length > 0)}
                    {maximos && maximos.length > 0 && arrayData.map((data, i) =>
                        <div key={`ubicacion${i}`} className={ubSelec === i ? 'col-md-12' : 'divUbicacion col-md-12'}>
                            <Card key={'ubicacionesCober' + i} >
                                {console.log("porete", data)}
                                <CardBody >
                                    <div className='container-body-spaces' style={{ marginTop: 10, }} >
                                        {arrayUbicaciones && < div className='flex container-body-spaces' style={{ flexWrap: 'wrap', }}>
                                            {arrayUbicaciones.map((data, i) => {
                                                let clase = 'botontabs'
                                                if (!data && ubSelec !== i) clase = `${clase} disabledAll`
                                                if (ubSelec === i) clase = `botontabsSelected ${clase}`
                                                return <div key={'botonesUbicacion' + i} className={clase} > {` Ubicación ${i + 1}`} </div>
                                            }
                                            )}
                                        </div>}
                                    </div>
                                    <Row className="mb-5 ">
                                        <Col sm={4} className=" hidden-xs "></Col>
                                        <Col sm={3} className=" hidden-xs "></Col>
                                        <Col sm={5} className=" hidden-xs "> <p style={{ textAlign: 'right', }}>Valor máximo por ubicación</p></Col>
                                    </Row>
                                    {data && data.length > 0 &&
                                        <ValoresCobertura
                                            key={`valCoberturas${i}`}
                                            data={data}
                                            i={i}
                                            handleBack={this.handleBack}
                                            handleClick={this.handleClick}
                                            final={arrayUbicaciones.length - 1 === i}
                                            idCobertura={idCobertura}
                                            cliCodigoCore={cliCodigoCore}
                                            mostrarRotura={guardar}
                                            estadoActualizar={this.state.estadoActualizar}
                                            setEstadoActualizar={this.setEstadoActualizar}
                                            hasSiguienteUbicacion={this.state.hasSiguienteUbicacion}
                                        />}
                                </CardBody>
                            </Card>
                        </div>
                    )}

                </div>
                {(estadoGenerales || data.length === 0) &&
                    <div className='row card'>
                        <Col md={12} className='card-body' style={{ background: '#fff', }}>
                            <div className='flex' style={{ justifyContent: 'space-between', }}>
                                <label style={{ fontWeight: 700, }}> Coberturas Generales: </label>
                                <label style={{ color: '#909090', }}>Valor Máximo</label>
                            </div>
                            {cobGenerales && cobGenerales.map(({ codigo, descripcion, valor }, i) =>
                                <>
                                    {codigo === "limiteEvento" && <label className={'mt-3 mb-2'} style={{ fontWeight: 600, }}> Carga y Descarga - Error de Despacho de Combustible </label>}
                                    <Row key={'coberGenerales' + i} className={(codigo === "limiteEvento" || codigo === "agregadoAnual") ? 'ml-2' : ''} >
                                        <Col xs={6} sm={4} > <p style={{ color: (parseInt(valor) === 0 ? '#989898' : null) }}>{descripcion}</p> </Col>
                                        <Col xs={6} sm={5}>

                                            <NumberFormat
                                                className="form-control"
                                                disabled={parseInt(valor) === 0}
                                                value={generales[codigo]}

                                                thousandSeparator={','}
                                                decimalSeparator={'.'}
                                                style={{
                                                    width: 'inherit', fontSize: 20,
                                                    textAlign: 'right', background: (parseInt(valor) === 0 ? '#f5f5f5' : null)
                                                }}
                                                decimalScale={2}
                                                prefix={''}
                                                onValueChange={(_valor, e) => {

                                                    console.log('Valor', _valor)
                                                    this.handleGenerales(_valor.floatValue, codigo, valor)


                                                }}

                                            />
                                        </Col>
                                        <Col sm={3}> <p style={{ textAlign: 'right', color: (parseInt(valor) === 0 ? '#989898' : null) }}>{valor.toLocaleString(navigator.language, { minimumFractionDigits: 0 })}</p> </Col>
                                    </Row>
                                </>
                            )}
                        </Col>
                        {console.log(maximos.length === 0, maximos)}
                        {maximos && maximos.length === 0 && <div className='flex' style={{ margin: 10, }}  >
                            <Button className="btn btn-detail-gray" onClick={() => this.handleBack()} style={{ margin: "auto" }} >
                                <i className="fa fa-chevron-circle-left" aria-hidden="true" />{"  REGRESAR"}
                            </Button>
                            <Button className={cambiaData} onClick={() => { /*setValidate(true);*/ this.handleClick([], 0, false) }} style={{ margin: "auto", }} >
                                <i className="fa fa-chevron-circle-right " aria-hidden="true" />{' ACTUALIZAR VALORES'}
                            </Button>
                        </div>}
                    </div>}
                {
                    nota.length > 0 &&
                    <div className='row card'>
                        <Col md={12} className='card-body' style={{ background: '#fff', }}>
                            <label style={{ fontWeight: 700, }}> Nota: </label>
                            {nota.map((item, i) => <p key={`notasCober${Math.random()}`} >{item}</p>)}
                        </Col></div>
                }

            </Col >
        )
    }
}
const mapStateToProps = (state, props) => ({
    coberturas: state.dataPymes.maxCoberturas,
    cobGenerales: state.dataPymes.coberturasGenerales[props.idCobertura],
    data: dataCoberturas(state, props),
    cliCodigoCore: state.datosUsuarios.dataUsuario.cliCodigoCore,
})

const mapDispatchToProps = dispatch => {
    return {
    };
};

export default withRouter(
    connect(
        mapStateToProps,
        mapDispatchToProps
    )(CompletarCoberturas)
);